/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface DocumentsZipResponse
 */
export interface DocumentsZipResponse {
  /**
   *
   * @type {string}
   * @memberof DocumentsZipResponse
   */
  base64Zip: string;
}

/**
 * Check if a given object implements the DocumentsZipResponse interface.
 */
export function instanceOfDocumentsZipResponse(
  value: object,
): value is DocumentsZipResponse {
  if (!("base64Zip" in value) || value["base64Zip"] === undefined) return false;
  return true;
}

export function DocumentsZipResponseFromJSON(json: any): DocumentsZipResponse {
  return DocumentsZipResponseFromJSONTyped(json, false);
}

export function DocumentsZipResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): DocumentsZipResponse {
  if (json == null) {
    return json;
  }
  return {
    base64Zip: json["base64Zip"],
  };
}

export function DocumentsZipResponseToJSON(json: any): DocumentsZipResponse {
  return DocumentsZipResponseToJSONTyped(json, false);
}

export function DocumentsZipResponseToJSONTyped(
  value?: DocumentsZipResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    base64Zip: value["base64Zip"],
  };
}
